"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDirection = exports.addFloat = exports.addRowProps = exports.addColProps = exports.addCheckboxProps = exports.addTableSticky = exports.addTextTransformation = exports.addTextAlign = exports.addAttachedVertical = exports.addAttachedHorizontal = exports.addAttached = void 0;

var _constants = require("../constants");

var _lib = require("../lib");

var _types = require("../lib/types");

var MEDIA_COL_MIN = 0;
var MEDIA_COL_MAX = 12; // attached

var addAttached = function addAttached() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 ? arguments[1] : undefined;

  if (value) {
    if ((0, _types.isStringMatch)(value, _constants.DIRECTION_ALL.concat(['horizontal', 'vertical']))) {
      (0, _lib.addClassName)(names, "attached-".concat(value));
    } else if ((0, _types.isBool)(value)) {
      (0, _lib.addClassName)(names, 'attached');
    }
  }
};

exports.addAttached = addAttached;

var addAttachedHorizontal = function addAttachedHorizontal() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 ? arguments[1] : undefined;

  if (value) {
    if ((0, _types.isStringMatch)(value, _constants.DIRECTION_HORIZONTAL)) {
      (0, _lib.addClassName)(names, "attached-".concat(value));
    } else if ((0, _types.isBool)(value)) {
      (0, _lib.addClassName)(names, 'attached-horizontal');
    }
  }
};

exports.addAttachedHorizontal = addAttachedHorizontal;

var addAttachedVertical = function addAttachedVertical() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 ? arguments[1] : undefined;

  if (value) {
    if ((0, _types.isStringMatch)(value, _constants.DIRECTION_VERTICAL)) {
      (0, _lib.addClassName)(names, "attached-".concat(value));
    } else if ((0, _types.isBool)(value)) {
      (0, _lib.addClassName)(names, 'attached-vertical');
    }
  }
}; // text align


exports.addAttachedVertical = addAttachedVertical;

var addTextAlign = function addTextAlign() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 ? arguments[1] : undefined;

  if (value && (0, _types.isStringMatch)(value, _constants.TEXT_ALIGNS)) {
    (0, _lib.addClassName)(names, "text-align-".concat(value));
  }
}; // text format


exports.addTextAlign = addTextAlign;

var addTextTransformation = function addTextTransformation() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var props = arguments.length > 1 ? arguments[1] : undefined;
  var keys = Object.keys(props);

  if ((0, _lib.arrayHasItems)(keys)) {
    keys.forEach(function (k) {
      if ((0, _types.isStringMatch)(k, _constants.TEXT_TRANSFORMS) && props[k]) {
        (0, _lib.addClassName)(names, k);
      }
    });
  }
}; // table


exports.addTextTransformation = addTextTransformation;

var addTableSticky = function addTableSticky() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sticky = arguments.length > 1 ? arguments[1] : undefined;
  var checkBoolean = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if ((0, _lib.arrayHasItems)(sticky)) {
    sticky.forEach(function (s) {
      if ((0, _types.isStringMatch)(s, _constants.ORDER_TYPES)) {
        (0, _lib.addClassName)(names, "sticky-".concat(s));
      }
    });
  } else if (checkBoolean && sticky) {
    (0, _lib.addClassName)(names, 'sticky');
  }
}; // checkbox


exports.addTableSticky = addTableSticky;

var addCheckboxProps = function addCheckboxProps() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var props = arguments.length > 1 ? arguments[1] : undefined;

  if (props) {
    _constants.CHECKBOX_TYPES.forEach(function (type) {
      if (props[type]) {
        (0, _lib.addClassName)(names, type);
      }
    });
  }
}; // column


exports.addCheckboxProps = addCheckboxProps;

var addColProps = function addColProps() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var props = arguments.length > 1 ? arguments[1] : undefined;

  if (props) {
    _constants.MEDIA_SIZES.forEach(function (mediaSize) {
      var value = props[mediaSize === 'xs' ? 'col' : mediaSize];

      if (value) {
        var size = mediaSize === 'xs' ? 'col' : "col-".concat(mediaSize);
        var colNumCondition = value > MEDIA_COL_MIN && value <= MEDIA_COL_MAX;
        var conditionCheck = (0, _types.isString)(value) && colNumCondition || (0, _types.isStringMatch)(value, _constants.COL_PROPS_PARAMS);

        if (conditionCheck) {
          // value is a string
          (0, _lib.addClassName)(names, "".concat(size, "-").concat(value));
        } else if ((0, _types.isNumber)(value) && colNumCondition) {
          // value is a number
          (0, _lib.addClassName)(names, "".concat(size, "-").concat(value));
        } else if ((0, _types.isBool)(value)) {
          // value is a bool
          (0, _lib.addClassName)(names, "".concat(size));
        }
      }
    });

    _constants.COL_PROPS.forEach(function (propName) {
      var value = props[propName];

      if (value || (0, _types.isNumber)(value)) {
        var colNumCondition = propName === 'order' ? value >= MEDIA_COL_MIN && value <= MEDIA_COL_MAX : value > MEDIA_COL_MIN && value < MEDIA_COL_MAX;
        var conditionCheck = propName === 'order' ? (0, _types.isString)(value) && colNumCondition || (0, _types.isNumber)(value) && colNumCondition || (0, _types.isStringMatch)(value, _constants.ORDER_TYPES) : (0, _types.isString)(value) && colNumCondition || (0, _types.isNumber)(value) && colNumCondition;

        if (conditionCheck) {
          (0, _lib.addClassName)(names, "".concat(propName, "-").concat(value));
        } else {
          _constants.MEDIA_SIZES.forEach(function (mediaSize) {
            var objValue = value[mediaSize];
            var baseClass = mediaSize === 'xs' ? "".concat(propName, "-").concat(objValue) : "".concat(propName, "-").concat(mediaSize, "-").concat(objValue);
            var colObjNumCondition = propName === 'order' ? objValue >= MEDIA_COL_MIN && objValue <= MEDIA_COL_MAX : objValue > MEDIA_COL_MIN && objValue < MEDIA_COL_MAX;
            var objConditionCheck = propName === 'order' ? (0, _types.isString)(objValue) && colObjNumCondition || (0, _types.isNumber)(objValue) && colObjNumCondition || (0, _types.isStringMatch)(objValue, _constants.ORDER_TYPES) : (0, _types.isString)(objValue) && colObjNumCondition || (0, _types.isNumber)(objValue) && colObjNumCondition;

            if (objValue || (0, _types.isNumber)(objValue)) {
              if (objConditionCheck) {
                // console.log(`${objValue} is a string / number`);
                (0, _lib.addClassName)(names, baseClass);
              }
            }
          });
        }
      }
    });

    _constants.COL_ALIGNMENT_PROPS.forEach(function (propName) {
      var value = props[propName];

      if (value) {
        if ((0, _lib.arrayHasItems)(value)) {
          value.forEach(function (v) {
            if ((0, _types.isStringMatch)(v, _constants.MEDIA_SIZES)) {
              (0, _lib.addClassName)(names, "".concat(propName, "-").concat(v));
            }
          });
        } else if ((0, _types.isObj)(value)) {
          _constants.MEDIA_SIZES.forEach(function (mediaSize) {
            if (value[mediaSize]) {
              (0, _lib.addClassName)(names, "".concat(propName, "-").concat(mediaSize));
            }
          });
        } else {
          (0, _lib.addClassName)(names, propName);
        }
      }
    });
  }
}; // row


exports.addColProps = addColProps;

var addRowProps = function addRowProps() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var props = arguments.length > 1 ? arguments[1] : undefined;

  if (props) {
    _constants.ROW_ALIGNMENT_PROPS.forEach(function (propName) {
      var value = props[propName];

      if (value) {
        if ((0, _lib.arrayHasItems)(value)) {
          value.forEach(function (v) {
            if ((0, _types.isStringMatch)(v, _constants.MEDIA_SIZES)) {
              (0, _lib.addClassName)(names, "".concat(propName, "-").concat(v));
            }
          });
        } else if ((0, _types.isObj)(value)) {
          _constants.MEDIA_SIZES.forEach(function (mediaSize) {
            if (value[mediaSize]) {
              (0, _lib.addClassName)(names, "".concat(propName, "-").concat(mediaSize));
            }
          });
        } else {
          (0, _lib.addClassName)(names, propName);
        }
      }
    });
  }
}; // float


exports.addRowProps = addRowProps;

var addFloat = function addFloat() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 ? arguments[1] : undefined;

  if (value && (0, _types.isStringMatch)(value, _constants.DIRECTION_HORIZONTAL)) {
    (0, _lib.addClassName)(names, "float-".concat(value));
  }
}; // direction


exports.addFloat = addFloat;

var addDirection = function addDirection() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments.length > 1 ? arguments[1] : undefined;
  var firstOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if ((0, _types.isStringMatch)(value, _constants.DIRECTION_ALL)) {
    (0, _lib.addClassName)(names, "direction-".concat(value));
  }

  if ((0, _lib.arrayHasItems)(value)) {
    if (firstOnly) {
      (0, _lib.addClassName)(names, "direction-".concat(value[0]));
      return;
    }

    var hasVertical = false;
    var hasHorizontal = false;
    value.forEach(function (v) {
      if ((0, _types.isStringMatch)(v, _constants.DIRECTION_ALL)) {
        var isVertical = (0, _types.isStringMatch)(v, _constants.DIRECTION_VERTICAL);

        if (isVertical && !hasVertical || !isVertical && !hasHorizontal) {
          (0, _lib.addClassName)(names, "direction-".concat(v));

          if (isVertical) {
            hasVertical = true;
          } else {
            hasHorizontal = true;
          }
        }
      }
    });
  }
};

exports.addDirection = addDirection;